import { TReduxActions } from '../../../types/redux';
import { EUserStatusActionTypes } from '../../../actions/newReview';
import { EUserStatus } from '../../../types/newReview/userStatus';
import { TUserStatusRating } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';

export const defaultValue: TUserStatusRating = {
  value: EUserStatus.Seeker,
};

export function userStatusReducer(
  state: TUserStatusRating = defaultValue,
  { type, payload }: TReduxActions,
): TUserStatusRating {
  if (type === EUserStatusActionTypes.SetUserStatus) {
    return {
      value: payload as EUserStatus,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
